<template>
  <div style="position: relative; border-radius: 12px; overflow: hidden;">
    <BrandModal v-if="selectedBrand !== null" :selectedBrand="selectedBrand"
                @close="onModalClose"
                @created="onCreatedCallback"
                @edited="onEditedCallback"
                @deleted="onDeleteCallback"
    />
    <LoadingSpinner v-if="loading" />

    <section class="connections-section">
      <div class="setting-content--section">
        <div class="connections-section--header">
          <div class="connections-section--header__title">
            <h3>{{ $gettext('Current Brands') }}</h3>
            <p>{{ $gettext('These are the brands that you have currently set up.') }}</p>
          </div>
          <div>
            <GekkoButton
              @click="openBrandModal(0, '')"
              :text="$gettext('Add brand')"
              :icon="'fa-solid fa-user-plus'"
            />
          </div>
        </div>
        <div class="connections-list">
          <BrandCard
            v-for="(brand, index) in availableBrands" :key="'conn-active-' + index"
            :brand-data="brand"
            @click.native="openBrandModal(brand.id, brand.name)"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import GekkoButton from "@/components/GekkoButton"

import BrandCard from "@/components/brands/BrandCard"
import BrandModal from "@/components/brands/BrandModal"

import settingsPageSetup from "@/mixins/settingsPageSetup"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: "Brands",
  components: {
    GekkoButton,
    BrandCard,
    LoadingSpinner,
    BrandModal
  },
  mixins: [ settingsPageSetup ],
  data () {
    return {
      pageSettings: {
        title: this.$gettext("Brands"),
        showCompanyPicker: true
      },
      loading: true,
      selectedBrand: null,
    }
  },
  computed: {
    ...mapGetters({
      isPremium: 'getIsPremium',
      availableBrands: 'brands/getAvailableBrands',
    }),
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions({
      loadBrandsMainData: 'brands/loadBrandsMainData',
    }),
    initData () {
      this.loading = true
      this.loadBrandsMainData(window.company_id).then(() => {
        this.$nextTick(() => {
          this.loading = false
        })
      });
    },
    onEditedCallback(){
      this.initData();
      this.onModalClose();
    },
    onCreatedCallback(){
      this.initData();
      this.onModalClose();
    },
    onDeleteCallback(){
      this.initData();
      this.onModalClose();
    },
    openBrandModal (brand_id, brand_name) {
      this.$store.commit('brands/SET_SELECTED_BRAND_NAME', brand_name);
      this.$store.commit('brands/SET_SELECTED_BRAND_ID', brand_id);
      this.selectedBrand = brand_id;
    },
    onModalClose () {
      this.$store.commit('brands/SET_SELECTED_BRAND_NAME', "");
      this.$store.commit('brands/SET_SELECTED_BRAND_ID', null);
      this.selectedBrand = null
    }
  }
}
</script>
<style lang="scss">
  .brand-card-wrap {
    padding: 0.5rem;
    display: flex;
    width: 100%;
    cursor: pointer;

    .itsme {
      .connection-card__info--name { color: $colorBlue; }
    }
  }

</style>
<style scoped lang="scss">
  .connections-section {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
    &--header {
      &__title { max-width: 650px; }
      p { font-size: 0.875rem; opacity: 0.6; }
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      margin-bottom: 1rem;
      .btn-primary { width: 100%; }

      @media (min-width: 576px) {
        flex-direction: row;
        margin-bottom: 0;
        .btn-primary { width: auto; }
      }
    }
  }
  .connections-list {
    display: flex;
    flex-direction: column;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  .connections-list + .connections-list {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid $colorBorderDash;
  }
  .upgrade-teamsize-content-wrap {
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 1rem;
    align-items: center;
  }
</style>
